import React from 'react';
import styled from 'styled-components';

const PerksWrapper = styled.section`
	display: flex;
	flex-direction: column;
	background-color: #fcfcfc;

	@media only screen and (min-width: 900px) {
		display: flex;
		flex-direction: column;
		background-color: #fcfcfc;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 96px 0;
		background-image: url('data:image/svg+xml;base64, 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');
		background-repeat: no-repeat;
		background-position: top;
	}

	.hostjane-main-Perks__perks {
		flex: auto;
		padding-top: 32px;
		padding-bottom: 32px;
		order: 1;
		padding: 16px;

		@media screen and (min-width: 900px) {
			order: 0;
			width: 352px;
			margin-right: 64px;
			flex: none;
			padding: 0;
		}
		h2 {
			font-size: 28px;
			font-weight: 900;
			line-height: initial;
		}
		ul {
			list-style: none;
			padding: 0;
			margin-top: 16px;
		}
	}
	.hostjane--main-Perks__requirements {
		padding: 16px;
		flex: auto;
		padding-top: 32px;
		padding-bottom: 32px;
		order: 0;
		background-color: #fff;
		box-shadow: 10px 10px 50px 0px rgba(0, 0, 0, 0.2);

		@media screen and (min-width: 900px) {
			flex: none;
			order: 1;
			width: 352px;
			font-size: 18px;
			padding: 24px;
		}

		h2 {
			font-size: 28px;
			font-weight: 900;
			line-height: initial;
		}
		ul {
			list-style: none;
			padding: 0;
			margin-top: 16px;
			@media only screen and (min-width: 900px) {
				margin-top: 32px;
			}
		}
	}
`;

const Li = styled.li`
	display: grid;
	grid-template-columns: ${props => props.svgWidth} auto;
	grid-gap: ${props => props.gridGap};
	align-items: flex-start;
	margin-top: ${props => props.margin};
	min-height: 24px;
	min-height: ${props => props.minHeight};
	font-size: ${props => props.fontsize};
	line-height: 28px;
	svg {
		width: ${props => props.svgWidth};
		height: ${props => props.svgWidth};
		margin-top: 4px;
	}

	@media screen and (max-width: 900px) {
		margin-top: 16px;
	}
	a {
		text-decoration: none;
		color: #00ccbc;
		&:hover {
			text-decoration: none;
			color: #00b4ad;
		}
	}
`;

const Perks = ({
	leftSectionHeading,
	leftSectionBulletsData,
	rightSectionHeading,
	rightSectionBulletsData,
}) => {
	return (
		<PerksWrapper className="hostjane-main-Perks">
			<div className="hostjane-main-Perks__perks">
				<h2>{leftSectionHeading}</h2>
				<ul>
					{leftSectionBulletsData.map(
						({ icon, bullet, linkText, link }) => {
							return (
								<Li
									margin="40px"
									minHeight="48px"
									svgWidth="55px"
									fontsize="18px"
									gridGap="25px"
								>
									{icon}
									<div>
										{bullet}
										{linkText && (
											<>
												<br />
												<br />
												<a alt="" href={link}>
													{linkText}
												</a>
											</>
										)}
									</div>
								</Li>
							);
						}
					)}
				</ul>
			</div>
			<div className="hostjane--main-Perks__requirements">
				<h2>{rightSectionHeading}</h2>
				<ul>
					{rightSectionBulletsData.map(({ bullet, icon }) => {
						return (
							<Li
								margin="24px"
								paddingLeft="40px"
								minHeight="auto"
								svgWidth="23px"
								fontsize="18px"
								gridGap="17px"
							>
								{icon}
								<div>{bullet}</div>
							</Li>
						);
					})}
				</ul>
			</div>
		</PerksWrapper>
	);
};

export default Perks;
